import { type MutationHookOptions, useMutation } from "@apollo/client";
import { UpdateProductsMutation } from "../graphql/mutations";
import type {
  UpdateProductsMutationType,
  UpdateProductsMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useUpdateProductsMutation = (
  options?: MutationHookOptions<
    UpdateProductsMutationType,
    UpdateProductsMutationVariablesType
  >
) => {
  return useMutation<
    UpdateProductsMutationType,
    UpdateProductsMutationVariablesType
  >(UpdateProductsMutation, options);
};
